import { Mtds } from 'prove-common'

export const FileList = ({
  title,
  children
}: {
  title: string
  children: React.ReactNode
}) => (
  <Mtds.Grid>
    <Mtds.Heading as='h2'>{title}</Mtds.Heading>
    <Mtds.Grid as={'ol'}>{children}</Mtds.Grid>
  </Mtds.Grid>
)
